export const PopoverProps = {
  baseStyle: {
    content: {
      bg: 'white',
      borderRadius: '14px',
      border: '1px solid',
      borderColor: 'solid.50',
      boxShadow:
        '0px 0px 0px 1px rgba(93, 94, 203, 0.06), 0px 4px 6px -2px rgba(93, 94, 203, 0.04), 0px 12px 24px -4px rgba(13, 13, 18, 0.10)',
      _focusVisible: {
        outline: 'none',
        boxShadow:
          '0px 0px 0px 1px rgba(93, 94, 203, 0.06), 0px 4px 6px -2px rgba(93, 94, 203, 0.04), 0px 12px 24px -4px rgba(13, 13, 18, 0.10)',
      },
    },
    header: {
      borderBottomWidth: '1px',
      borderColor: 'solid.50',
      fontWeight: '600',
      fontSize: '14px',
      px: '16px',
      py: '12px',
    },
    body: {
      px: '8px',
      py: '8px',
    },
    footer: {
      borderTopWidth: '1px',
      borderColor: 'solid.50',
      px: '16px',
      py: '12px',
    },
    arrow: {
      bg: 'white',
      borderColor: 'solid.50',
    },
  },
}
